import { Component, EventEmitter, Input, OnChanges, Output, forwardRef } from '@angular/core';
import { CommonService } from 'src/app/_services/common.service';
import { Form, Assignment } from '../../../../../interfaces/common-interface';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
@Component({
  selector: 'app-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropDownComponent),
      multi: true
    }
  ]
})
export class DropDownComponent implements OnChanges, ControlValueAccessor {
  @Input() dropDownData: Assignment;
  @Input() formData: Form;
  @Input() patchData;
  @Output() dropDownIds = new EventEmitter();
  // Property for the internal value
  public value: any = null;
  private onChange: (value: any) => void = (value: any) => {
    // No-op: This method is required by ControlValueAccessor but doesn't need to do anything
  };
  
  private onTouched: () => void = () => {
    // No-op: This method is required by ControlValueAccessor but doesn't need to do anything
  };
   
  count = 0;
  originalData = [];
  searchRecord: string;
  isUserInput = false;
  selectedIds = [];
  constructor(public cos: CommonService) { }

  ngOnChanges() {
    if (!Array.isArray(this.patchData) && this.patchData) {
      if (this.patchData.ids)
        this.formData.patchValue({
          [this.patchData.name]: this.patchData.ids
        });
    }
  }

  searchRecordName(data: string, fieldName: string, tableData) {
    if (this.count === 0) {
      this.originalData = tableData;
    }
    this.count++;
    if (data) {
      const filteredData = this.originalData.filter((item) =>
        item.value.toLowerCase().includes(data.toLowerCase())
      );
      if (this.dropDownData.name === fieldName) {
        this.dropDownData.multipleValues = filteredData;
      }
    } else {
      if (this.dropDownData.name === fieldName) {
        this.dropDownData.multipleValues = this.originalData;
      }
    }
  }

  triggerEvent(data: boolean, fieldName: string, arr) {
    this.count = 0;
    if (!data) {
      if (this.dropDownData.name === fieldName) {
        this.dropDownData.multipleValues = this.originalData.length ? this.originalData : arr;
      }
      this.searchRecord = '';
    }
  }

  patchSelectedValue(
    selectionState: boolean, 
    id: string, 
    fieldName: string, 
    singleSelection: boolean, 
    value: string
  ) {
    if (!id) return; // Ensure valid id
  
    if (selectionState) {
      // If selected, add the ID
      this.selectedIds.push(id);
    } else {
      // If deselected, remove the ID
      this.selectedIds = this.selectedIds.filter(existingId => existingId !== id);
    }
  
    this.selectedIds = this.selectedIds.flat();
    this.selectedIds = this.cos.removeDuplicates(this.selectedIds);
  
    if (this.selectedIds.length === 0) {
      this.selectedIds = [];
    }
  
    this.dropDownIds.emit({
      name: fieldName,
      ids: singleSelection ? (selectionState ? id : "") : this.selectedIds,
      assignId: id,
      state: selectionState,
      dropDownData: this.dropDownData,
      isSelected: selectionState, 
      value: value
    });
  }

   // Called when the model is updated by the parent
   writeValue(value: any): void {
    this.value = value;
    if (Array.isArray(value)) {
      this.selectedIds = [...value];
    } else {
      this.selectedIds = value ? [value] : [];
    }
  }

  // Save the function that Angular passes to handle changes from your component
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  // Save the function that Angular passes to handle touches
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
